
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-hotels",
      function () {
        return require("private-next-pages/our-hotels/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/our-hotels"])
      });
    }
  